import React from "react";
import { AppBar, Toolbar, IconButton, makeStyles, Theme, createStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Typography from "@material-ui/core/Typography";
import { useHistory } from "react-router-dom";
import { getRoles } from "./dashboardHelpers";
import YellowBox from "./YellowBox";

const useStylesSubHeader = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    menuButton: {
      marginLeft: theme.spacing(1),
    },
    centerText: {
      color: "#FFF",
      fontSize: 18,
      fontWeight: 700,
      opacity: 0.36,
      textTransform: "none",
    },
    centerButton: {
      minWidth: 0,
      padding: "5px 15px",
    },
  })
);

const SubHeader = ({
  leftButtonClick,
  showArrow = true,
  title = "All Hospitals",
  activeOption = "last30days",
  setActiveOption,
  authStore,
}: any): JSX.Element => {
  const classes = useStylesSubHeader();
  const history = useHistory();
  const userRoles = getRoles(authStore);
  const active = { color: "#F4B827", opacity: 1 };
  return (
    <div className={classes.root}>
      <AppBar position="static" style={{ backgroundColor: "#01224A" }}>
        <Toolbar variant="dense" style={{ justifyContent: "space-between" }}>
          <span
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Button className={classes.centerButton} onClick={() => setActiveOption("last30days")}>
              <Typography className={classes.centerText} style={activeOption == "last30days" ? active : {}}>
                Last 30 Days
              </Typography>
            </Button>
            <Button className={classes.centerButton} onClick={() => setActiveOption("thismonth")}>
              <Typography className={classes.centerText} style={activeOption == "thismonth" ? active : {}}>
                This Month
              </Typography>
            </Button>
            <Button className={classes.centerButton} onClick={() => setActiveOption("thisyear")}>
              <Typography className={classes.centerText} style={activeOption == "thisyear" ? active : {}}>
                This Year
              </Typography>
            </Button>
            <Button className={classes.centerButton} onClick={() => setActiveOption("lastmonth")}>
              <Typography className={classes.centerText} style={activeOption == "lastmonth" ? active : {}}>
                Last Month
              </Typography>
            </Button>
            <Button className={classes.centerButton} onClick={() => setActiveOption("lastyear")}>
              <Typography className={classes.centerText} style={activeOption == "lastyear" ? active : {}}>
                Last Year
              </Typography>
            </Button>
            <Button className={classes.centerButton} onClick={() => setActiveOption("custom")}>
              <Typography className={classes.centerText} style={activeOption == "custom" ? active : {}}>
                Custom
              </Typography>
            </Button>
          </span>

          {userRoles?.CanViewDashboardAsSMA || userRoles?.IsAdmin || userRoles.IsCustomer? (
            <span
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              {!showArrow && (
                <Typography variant="h6" style={{ color: "#FFF", fontSize: 18, fontWeight: 400 }}>
                  {title}
                </Typography>
              )}
              {showArrow && (
                <>
                  <Typography variant="h6" style={{ color: "#FFF", fontSize: 18, fontWeight: 400, cursor: "pointer" }} onClick={leftButtonClick}>
                    {title}
                  </Typography>
                  <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" onClick={leftButtonClick}>
                    <KeyboardArrowDownIcon />
                  </IconButton>
                </>
              )}
            </span>
          ) : userRoles?.CanViewDashboardAsSMA ? (
            <Button style={{ minWidth: 0, padding: 0 }}>
              <YellowBox title="View/Track Bookings" onClick={() => history.push("/transferSchedule")} />
            </Button>
          ) : null}
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default SubHeader;
